import { FormErrors, SubmissionError } from 'redux-form'

/**
 * Format the error message so that it can be handled by Redux-Form.
 *
 * The fieldKeysMap paramters allows to map the field key returned by the API (eg. name.invalid) with the field key
 * used by Redux-Form, when they are different.
 */
export const formatSubmissionError = (
  errorMessage: string | FormErrors,
  fieldKeysMap: Record<string, string> = {},
  prefix = '',
) => {
  let formattedMessage: FormErrors
  if (typeof errorMessage === 'string') {
    const [apiKey] = errorMessage.split('.')
    const fieldKey = fieldKeysMap[apiKey] || apiKey
    const [translationKey, namespace] = errorMessage.split(':').reverse()
    const message = `trans:${!namespace || namespace === 'trans' ? 'common' : namespace}:${
      prefix ? prefix + '.' : ''
    }${translationKey}`
    formattedMessage = {
      _error: message,
      [fieldKey]: message,
    }
  } else {
    formattedMessage = errorMessage
  }
  return new SubmissionError(formattedMessage)
}
